"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer } from "@nxt-costco-com/forge-components";
import { NavItem } from "../NavItem/index.js";
import { UserInfo } from "../UserInfo/index.js";
import { findBodyTextItemByDevFieldKey } from "../utils.js";
import { ACCOUNT_PANEL_ARIA_LABEL_DEV_KEY, CLOSE_BUTTON_ARIA_LABEL_DEV_KEY, COMPONENT_NAME } from "../../constants.js";
import { getMenuItems } from "../../../common/util/index.js";
import { Analytics } from "../../../../Analytics/index.js";
const AccountDrawerUI = ({
  moduleSettings,
  locale,
  membershipTypes,
  memberStatus,
  isLoading,
  isOpen,
  accountMenuOptions,
  onClose,
  onSignOut
}) => {
  if (!moduleSettings || !accountMenuOptions) return null;
  const menuItems = getMenuItems({
    memberStatus,
    moduleSettings,
    accountMenuOptions,
    appendedToId: "DrawerNavigation"
  });
  const accountPanelAriaLabel = findBodyTextItemByDevFieldKey(
    moduleSettings.composable_window,
    ACCOUNT_PANEL_ARIA_LABEL_DEV_KEY
  );
  const closeButtonAriaLabel = findBodyTextItemByDevFieldKey(
    moduleSettings.composable_window,
    CLOSE_BUTTON_ARIA_LABEL_DEV_KEY
  );
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          identifier: "Account Flyout",
          type: "nav"
        },
        trackType: "navigation"
      },
      children: /* @__PURE__ */ jsxs(
        Drawer,
        {
          PaperProps: {
            "aria-label": accountPanelAriaLabel
          },
          anchor: "right",
          bodySx: { margin: 0 },
          closeAriaLabel: closeButtonAriaLabel,
          onClose,
          open: isOpen,
          uniqueId: "accountdrawer",
          children: [
            /* @__PURE__ */ jsx(
              UserInfo,
              {
                isLoading,
                locale,
                memberStatus,
                membershipTypes,
                moduleSettings
              }
            ),
            menuItems.map((item, index) => /* @__PURE__ */ jsx(
              NavItem,
              {
                icon: item.icon,
                classicMenuKey: item.classicMenuKey,
                id: item.id,
                isLoading,
                label: item.label,
                onSignOut,
                to: item.to ?? "",
                isSignOutItem: item.isSignOutItem
              },
              `${item.label}-${index}`
            ))
          ]
        }
      )
    }
  );
};
AccountDrawerUI.displayName = COMPONENT_NAME;
export {
  AccountDrawerUI
};
